<template>
    <v-container fluid fill-height>
      <!-- Buttons -->
      <span>
        <v-btn
          color="#082FB1"
          variant="flat"
          prepend-icon="mdi-sync"
          class="rounded-lg"
          @click.stop.prevent="triggerFileInput"
          v-if="showCard === 'product'"
        >
          Sync
        </v-btn>
      </span>
  
      <v-tooltip text="Upload a file" location="bottom">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            class="upload-btn"
            elevation="4"
            @click.stop.prevent="triggerFileInput"
            color="#082FB1"
            variant="flat"
            prepend-icon="mdi-upload"
            v-if="showCard === 'customer'"
          >
            Upload
          </v-btn>
        </template>
      </v-tooltip>
  
      <!-- Drag & Drop Card -->
      <v-row align="center" justify="center" v-if="showCard === 'organisation'">
        <v-col
          cols="12"
          sm="6"
          md="12"
          style="border: 3px dashed #ccc; border-radius: 10px; padding: 0px !important;"
        >
          <v-card
            :disabled="!selected"
            :class="['d-flex flex-column align-center justify-center text-center', { 'drag-active': dragActive }]"
            style="width: 100%; height: 230px; cursor: pointer; box-shadow: none !important;"
            outlined
            tile
            @click="triggerFileInput"
            @dragover.prevent="onDragOver"
            @dragenter.prevent="onDragEnter"
            @dragleave.prevent="onDragLeave"
            @drop.prevent="onDrop"
          >
            <v-icon size="48">mdi-cloud-upload-outline</v-icon>
  
            <div style="font-size: 14px; color: #4b5563; line-height: 1.1; margin-top: 8px;">
              <div style="font-size: 18px;font-weight: 500;">
                Choose a file or drag & drop it here
              </div>
              <div class="my-2">{{processFlow? "Support only Images" :"Support for Excel, PPTX, PDF and image files up to 50MB"}}</div>
              <div style="margin-top:4px">
                or <a href="#" @click.stop.prevent="triggerFileInput">Click to upload files here</a>
              </div>
              <div v-if="fileName" style="margin-top:8px; font-size:13px; color:#111;">
                {{ fileName }}
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
  
      <input
        ref="fileInput"
        type="file"
        :accept="processFlow?'.png,.jpg,.jpeg,.svg': '.xlsx,.xls,.pdf,.doc,.docx,.png,.jpg,.jpeg,.gif,.ppt,.pptx'"
        style="display: none;"
        @change="handleFileSelect"
      />
    </v-container>
  </template>
  
  <script>
  import ClientDocumentsService from '@/api/service/ClientDocuments/ClientDocumentsService';
  export default {
    name: "UploadCard",
    props: ["showCard",'selected','processFlow','documentUpload'],
    data() {
      return {
        dragActive: false,
        fileName: "",
        base64Data: ""
      };
    },
    methods: {
      triggerFileInput() {
        this.$refs.fileInput.click();
      },
      onDragOver(e) {
        e.dataTransfer.dropEffect = "copy";
      },
      onDragEnter() {
        this.dragActive = true;
      },
      onDragLeave() {
        this.dragActive = false;
      },
      onDrop(e) {
        this.dragActive = false;
        const files = e.dataTransfer && e.dataTransfer.files;
        if (files && files.length) {
          this.processFile(files[0]);
        }
      },
      async handleFileSelect(e) {
        const file = e.target.files && e.target.files[0];
        if (file) {
          await this.processFile(file);
          e.target.value = "";
        }
      },
      async processFile(file) {
        this.fileName = file.name;
        const reader = new FileReader();
        reader.onload = async (ev) => {
          const base64String = ev.target.result;
          this.base64Data = base64String;
          if(this.documentUpload){
              let $json = {
                collectionName: 'documents',
                name: file.name,
                doc_name: file.name,
                file_name: file.name,
                key_type: "uploadFiles",
                key_id: this.$route.query.id,
                file_type: file.type,
                active: 1,
                src: base64String,
                profile:true
            };
            const docData = await ClientDocumentsService.create($json)
          
            console.log("Base64 Image:", docData);
            let $docid = docData.data.data._id
            let $s3Url = docData.data.data.s3Url
            console.log($docid ,"Base64 Image 1:", $s3Url);
          
              this.$emit("uploaded", {
                name: this.fileName,
                src: base64String,
                type: file.type,
                docId: $docid,
                s3Url: $s3Url
              });
          }
          else{
              this.$emit("uploaded", {
                name: this.fileName,
                src: base64String,
                type: file.type
              });
          }
              console.log("Uploaded File Base64:", base64String);
        };
        reader.readAsDataURL(file);
      },
      _preventWindowDrop(e) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    mounted() {
      window.addEventListener("dragover", this._preventWindowDrop);
      window.addEventListener("drop", this._preventWindowDrop);
    },
    beforeUnmount() {
      window.removeEventListener("dragover", this._preventWindowDrop);
      window.removeEventListener("drop", this._preventWindowDrop);
    }
  };
  </script>
  
  <style scoped>
  .drag-active {
    border-color: #1976d2 !important;
    box-shadow: 0 6px 18px rgba(25, 118, 210, 0.12);
    transform: translateY(-1px);
  }
  a {
    color: #1976d2;
    text-decoration: none;
  }
  </style>
  